import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import img_pages_aboutus_lanhu_1 from '@/assets/images/pages-aboutus-lanhu-1.png';
import img_pages_aboutus_lanhu_2 from '@/assets/images/pages-aboutus-lanhu-2.png';
import img_pages_aboutus_lanhu_3 from '@/assets/images/pages-aboutus-lanhu-3.png';

const AboutUs = () => {
  return (
    <div className={styles['about-us-page']}>
      <div className={styles.page}>
        <section className={styles['about-hero']}>
          <div className={styles['about-hero__overlay']}>
            <SiteTopNav />
            <div className={styles['about-hero__content']}>
              <h1 className={styles['about-hero__title']} data-motion="hero">
                About Sakura Floors
              </h1>
              <p className={styles['about-hero__lead']} data-motion="copy">
                With years of expertise and experience, Sakura Floors is proud to be regarded as a
                manufacturing leader. Every decision is inspired by our main mission, which is to
                provide the highest standard of product and services to both retailers and
                customers.
              </p>
              <p className={styles['about-hero__lead']} data-motion="copy">
                In this rapidly changing industry, we’ve realized the importance of continually
                updating our approach to stay relevant in the market, and are committed to just
                that. We invite you to browse through our inventory and contact us with any
                questions.
              </p>
            </div>
          </div>
        </section>

        <section className={styles['about-certifications']}>
          <h2 className={styles['about-certifications__title']} data-motion="title">
            Certifications
          </h2>

          <div className="fix-width">
            <article className={styles.certification} data-motion="card">
              <div className={styles['certification__body']}>
                <h3 className={styles['certification__heading']}>LACEY Act Compliant</h3>
                <p className={styles['certification__text']}>
                  The Lacey Act (16 U.S.C. 3371 et seq., the Act) as amended makes it unlawful to
                  import, export, transport, sell, receive, acquire, or purchase in interstate or
                  foreign commerce any plant, with some limited exceptions, taken or traded in
                  violation of the laws of the United States, a U.S. State or a foreign country. The
                  Lacey Act combats illegal trafficking of wildlife, fish, and plants. It is against
                  the law to import into the United States any illegally harvested plant or plant
                  product, and certain products require a declaration. All our products are LACEY
                  Act compliant.
                </p>
              </div>
              <div
                className={`${styles['certification__media']} ${styles['certification__media--lacey']}`}
              >
                <img
                  className={`${styles['certification__badge']} ${styles['certification__badge--lacey']}`}
                  alt=""
                  referrerPolicy="no-referrer"
                  src={img_pages_aboutus_lanhu_1}
                />
              </div>
            </article>

            <article
              className={`${styles.certification} ${styles['certification--reversed']}`}
              data-motion="card"
            >
              <div className={styles['certification__body']}>
                <h3 className={styles['certification__heading']}>
                  CARB Phase 2 and EPA TSCA Title VI Compliant
                </h3>
                <p className={styles['certification__text']}>
                  CARB (California Air Resources Board) certification limits formaldehyde emissions
                  from composite wood products—including the plywood and MDF cores used in Abode
                  engineered floors. CARB is law in California only, but the US Environmental
                  Protection Agency has adapted the regulation for nationwide enforcement as a new
                  title or section to the Toxic Substances Control Act (TSCA), called Title VI.
                  <br />
                  Neither CARB nor TSCA regulate flooring directly; rather these regulations set
                  limits on formaldehyde emissions from specific composite wood products–namely
                  plywood, fiberboard (MDF) and particle board, which are utilized as cores in Abode
                  engineered flooring. All Abode floors produced with plywood and MDF core
                  components meet CARB/TSCA formaldehyde emissions standards, regardless if they are
                  being sold in the U.S. or Canada. (The Canadian government is currently developing
                  a regulation to govern formaldehyde emissions from composite wood products. Since
                  it is expected to be aligned with TSCA, all Abode products should be able to
                  comply without difficulties).
                </p>
              </div>
              <div
                className={`${styles['certification__media']} ${styles['certification__media--carb']}`}
              >
                <img
                  className={`${styles['certification__badge']} ${styles['certification__badge--carb']}`}
                  alt=""
                  referrerPolicy="no-referrer"
                  src={img_pages_aboutus_lanhu_2}
                />
              </div>
            </article>

            <article className={styles.certification} data-motion="card">
              <div className={styles['certification__body']}>
                <h3 className={styles['certification__heading']}>
                  Beyond CARB and TSCA: CA Section 01350 Compliant
                </h3>
                <p className={styles['certification__text']}>
                  But CARB and TSCA only regulate the core of the floor. We go a step further: We
                  test Abode against CA Section 01350, which sets allowable formaldehyde emissions
                  level at less than half of CARB/TSCA. More importantly, CA Section 01350 tests the
                  whole product that goes into your home, not just the core, and it tests for
                  thousands of other chemical emissions in addition to formaldehyde. CA Section
                  01350 gives a much more comprehensive indication of a product’s impact on your
                  indoor air quality than either CARB or TSCA alone, and is recognized by LEED as a
                  qualifying attribute for low emitting materials credits. All Abode engineered
                  flooring is CA Section 01350 Compliant.
                </p>
              </div>
              <div
                className={`${styles['certification__media']} ${styles['certification__media--section01350']}`}
              >
                <img
                  className={`${styles['certification__badge']} ${styles['certification__badge--section01350']}`}
                  alt=""
                  referrerPolicy="no-referrer"
                  src={img_pages_aboutus_lanhu_3}
                />
              </div>
            </article>
          </div>

          <div className={styles['about-support']} data-motion="section">
            <h2 className={styles['about-support__title']} data-motion="title">
              We&apos;re here for you.
            </h2>
            <p className={styles['about-support__text']} data-motion="copy">
              As a trusted partner in the flooring industry, we are dedicated to delivering superior
              products and an enhanced service experience.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
